(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function () {
  function loadRecommendations(root) {
    var sections = root.querySelectorAll('.related-products[data-url]');
    sections.forEach(function (section) {
      if (section.dataset.recommendationsLoading === 'true') return;
      section.dataset.recommendationsLoading = 'true';
      fetch(section.dataset.url)
        .then(function (response) {
          if (!response.ok) throw new Error('Recommendations request failed');
          return response.text();
        })
        .then(function (html) {
          if (!section.isConnected) return;
          var container = document.createElement('div');
          container.innerHTML = html;
          var result = container.querySelector('.related-products');
          if (result) section.innerHTML = result.innerHTML;
        })
        .catch(function () {
          // Keep the section empty if recommendations cannot be loaded.
        })
        .finally(function () {
          delete section.dataset.recommendationsLoading;
        });
    });
  }
  document.addEventListener('shopify:section:load', function (event) {
    loadRecommendations(event.target);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      loadRecommendations(document);
    }, { once: true });
  } else {
    loadRecommendations(document);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
